var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-table',{attrs:{"hover":"","small":"","striped":"","borderless":"","responsive":"true","head-variant":"dark","items":_vm.activeProxies}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }